import type { Candidate } from 'model/Candidate/Candidate';

import { queryClient } from 'config/queryClient';
import { CandidateHistoryQueryData } from 'shared/legacy/hooks/useCandidateHistoryQuery.types';
import { QueryKey } from 'types/query';

export const isAReplyMessage = (candidate: Pick<Candidate, 'es_person_id' | 'status'>) => {
  const candidateHistoryData = queryClient.getQueryData<CandidateHistoryQueryData>([
    QueryKey.useCandidateHistoryQuery,
    { candidateEsPersonId: candidate?.es_person_id, status: candidate?.status },
  ]);

  return candidateHistoryData?.data.some((history) => history.messageReceived) || false;
};
